export default __webpack_public_path__ + "static/media/Mando-Icon.f4a7b59d.svg";